export interface UserManagementRole {
  description: string
  label: string
}
